import { render, staticRenderFns } from "./faceMatch.vue?vue&type=template&id=600ef7d7&scoped=true"
import script from "./faceMatch.vue?vue&type=script&lang=js"
export * from "./faceMatch.vue?vue&type=script&lang=js"
import style0 from "./faceMatch.vue?vue&type=style&index=0&id=600ef7d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600ef7d7",
  null
  
)

export default component.exports